import { Window } from '@execonline-inc/browser-window.private';
import { Task } from 'taskarian';
import { Error } from '../ErrorHandling';

const navigationError = (): Error => ({
  kind: 'error',
  message: 'An error occurred, please refresh the page and try again',
});

export const pathname = (): Task<Error, string> =>
  Window.readT('location')
    .map((loc) => loc.pathname)
    .mapError(navigationError);

export const assign = (url: string): Task<Error, void> =>
  Window.locationRedirect(url).mapError(navigationError);
